import { groupLifeService } from '@/services';
import type {
  GroupLifeMemberCrudResponse,
  GroupLifeQuoteDetails,
} from '@/services/group-life';
import { useQuery } from '@tanstack/react-query';

/** Target do estipulante master nos endpoints de vidas do Group Life. */
const STIPULATOR_TARGET = '__STIPULATOR__';

/**
 * Carrega TODAS as vidas (dados crus, incluindo `awayFromWork` e `cids`) da
 * proposta PME — estipulante master + subestipulantes. Usado pelas abas de
 * análise (Idade/Capital e Afastados) que precisam do detalhe completo, não
 * apenas do `PmeLifeRow` simplificado.
 */
export function usePmeProposalAnalysisMembers(
  policyId: string | undefined,
  details: GroupLifeQuoteDetails | undefined
) {
  const subIds = (details?.subStipulators ?? []).map(s => s.id);

  const query = useQuery({
    queryKey: ['pme-proposal-analysis-members', policyId, subIds],
    queryFn: async (): Promise<GroupLifeMemberCrudResponse[]> => {
      if (!policyId) return [];
      const targets = [STIPULATOR_TARGET, ...subIds];
      const perTarget = await Promise.all(
        targets.map(async targetId => {
          const res = await groupLifeService.listMembersByTarget({
            quoteId: policyId,
            targetId,
          });
          return res.success && res.data ? res.data : [];
        })
      );
      return perTarget.flat();
    },
    enabled: !!policyId,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return {
    members: query.data ?? [],
    isLoading: query.isLoading,
  };
}
